export default function() {
    if (this.$store.state.profileSearchFilters) {
        this.filters = this.$store.state.profileSearchFilters
    }
    this.loadSymplaEvents()
    this.searchProfessionals()
}
